// extracted by mini-css-extract-plugin
export default {"wrapper":"FTUOlCqnkYTEGXq5DRBQ","button":"afmoP5nNf6343PUdADQJ","icon":"ryWkr9DSuSSuxe0vZb3Q"};